import React from 'react';
import { List } from 'react-admin';
import Box from '@mui/material/Box';

import { useTitle } from '@src/hooks/useTitle';
import WithPricingGuard from './WithPricingGuard';
import PricingRulesStatusBanner from './PricingRulesStatusBanner';
import PricingRulesToolbar from './PricingRulesToolbar';
import PricingRulesDataTable from './PricingRulesDataTable';
import PricingRulesActions from './PricingRulesActions';
import PricingRulesDocumentation from './PricingRulesDocumentation';

const PRICING_TYPE = 'yerdle_price' as const;

const PricingRulesList = () => {
  const { title } = useTitle('Pricing Rules');

  return (
    <WithPricingGuard>
      <List
      perPage={10}
      sort={{ field: 'position', order: 'ASC' }}
      title={title}
      actions={<PricingRulesActions pricingType={PRICING_TYPE} />}
    >
        <PricingRulesStatusBanner pricingType={PRICING_TYPE} />
        <PricingRulesToolbar pricingType={PRICING_TYPE} />
        <PricingRulesDataTable pricingType={PRICING_TYPE} />
      </List>
      <Box sx={{ px: 2, pb: 2 }}>
        <PricingRulesDocumentation />
      </Box>
    </WithPricingGuard>
  );
};

export default PricingRulesList;
